import { BlockContent } from 'types/schema';

export interface Header {
  title: string;
  key: string;
}

export interface HandleScrollTo {
  id: string;
}

export const useScrollToHeaders = (content?: BlockContent) => {
  if (!content) return { headers: [], handleScrollTo: () => null };

  const headers: Header[] = content
    .filter((block) => {
      const [firstChild = {}] = block?.children || [];
      const title = block.title || firstChild.text;

      return (
        (block.style === 'h2' || block._type === 'section' || block._type == 'faqCategory') &&
        title.trim('\n')
      );
    })
    .map((block) => {
      const [firstChild = {}] = block?.children || [];

      const title = block.title || firstChild.text;
      const key = block._key || block._id;

      return { title, key };
    });

  function handleScrollTo(id: string) {
    const elementById = document.getElementById(id) || { scrollIntoView: () => null };

    if (elementById) {
      elementById.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
  return { headers, handleScrollTo };
};
